"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const labRequisitionJsonSchema = (allLabs) => ({
    type: "object",
    properties: {
        id: { type: "string", title: "Id" },
        labInformation: {
            type: "object",
            properties: {
                labId: {
                    title: "Lab",
                    type: "string",
                    oneOf: allLabs,
                },
            },
            required: ["labId"],
        },
        providerInformation: {
            type: "object",
            properties: {
                providerNPI: {
                    type: "integer",
                    title: "Provider NPI",
                },
            },
            required: ["providerNPI"],
        },
        specimenInformation: {
            type: "object",
            properties: {
                requisitionType: {
                    type: "string",
                    title: "Requisition Type",
                    oneOf: [
                        {
                            const: "Lab Collection Request",
                            title: "Lab Collection Request",
                        },
                        {
                            const: "Collected by Facility",
                            title: "Collected by Facility",
                        },
                        // { const: "Standing Order", title: "Standing Order" },
                    ],
                },
                collectionDate: {
                    type: "number",
                    format: "date",
                },
                collectionTime: {
                    type: "string",
                    description: "The time is subject to change, the lab will reach out to the patient",
                },
                collectionFrequency: {
                    type: "string",
                    oneOf: [
                        { const: "Weekly", title: "Weekly" },
                        { const: "Bi-Weekly", title: "Bi-Weekly" },
                        { const: "Monthly", title: "Monthly" },
                        { const: "Quarterly", title: "Quarterly" },
                        { const: "Semi Annual", title: "Semi Annual" },
                        { const: "Annually", title: "Annually" },
                    ],
                },
                collectionDays: {
                    type: "array",
                    uniqueItems: true,
                    items: {
                        oneOf: [
                            { const: "Monday", title: "Monday" },
                            { const: "Tuesday", title: "Tuesday" },
                            { const: "Wednesday", title: "Wednesday" },
                            { const: "Thursday", title: "Thursday" },
                            { const: "Friday", title: "Friday" },
                        ],
                    },
                },
                terminationDate: {
                    type: "number",
                    format: "date",
                },
            },
            required: ["requisitionType", "collectionDate"],
            if: {
                properties: { requisitionType: { const: "Standing Order" } },
            },
            then: {
                required: ["collectionFrequency", "collectionDays", "terminationDate"],
            },
        },
        tests: {
            type: "array",
            uniqueItems: true,
            minItems: 1,
            maxOneIDPanelPerRequisition: true,
            noBloodAndIDTogether: true,
            items: {
                type: "object",
                properties: {
                    labTest: {
                        title: "Panel / Test",
                        format: "lab-tests-autocomplete",
                        type: "string",
                    },
                },
                required: ["labTest"],
            },
            title: "Add panels / tests",
        },
        diagnosis: {
            type: "array",
            uniqueItems: true,
            minItems: 1,
            items: {
                type: "object",
                properties: {
                    icdCode: {
                        title: "ICD-10",
                        format: "icd10-autocomplete",
                        type: "string",
                    },
                },
                required: ["icdCode"],
            },
            title: "Add diagnosis",
        },
        comments: {
            type: "string",
        },
        patientInformation: {
            type: "object",
            properties: {
                id: { type: "string", title: "Group Id" },
                firstName: { type: "string", title: "First Name", minLength: 1 },
                lastName: { type: "string", title: "Last Name" },
                roomNo: { type: "string", title: "Room No" },
                dateOfBirth: {
                    type: "number",
                    format: "date",
                    disableFuture: true,
                },
                gender: {
                    title: "Gender",
                    type: "string",
                    oneOf: [
                        {
                            const: "Female",
                            title: "Female",
                        },
                        {
                            const: "Male",
                            title: "Male",
                        },
                    ],
                },
                addressOne: {
                    type: "string",
                    title: "Address 1",
                },
                addressTwo: {
                    type: "string",
                    title: "Address 2",
                },
                city: {
                    type: "string",
                    title: "City",
                },
                state: {
                    type: "string",
                    title: "State",
                },
                zipCode: {
                    type: "string",
                    title: "Zip Code",
                },
                phoneNumber: {
                    type: "string",
                    title: "Phone Number",
                    maxLength: 10,
                },
            },
            required: [
                "firstName",
                "lastName",
                "dateOfBirth",
                "gender",
                "addressOne",
                "city",
                "state",
                "zipCode",
                "phoneNumber",
            ],
        },
        insuranceInformation: {
            type: "object",
            properties: {
                policyType: {
                    type: "string",
                    title: "Policy Type",
                    oneOf: [
                        { const: "Medicare", title: "Medicare" },
                        { const: "Managed Medicare", title: "Managed Medicare" },
                    ],
                },
                mbi: {
                    type: "string",
                    pattern: "^[A-Z0-9]{11}$",
                    title: "MBI",
                    errorMessage: {
                        pattern: "invalid MBI",
                    },
                },
                policyNumber: {
                    type: "string",
                    title: "Policy Number",
                },
                policyProvider: {
                    type: "string",
                    title: "Policy Provider",
                },
            },
            required: ["policyType"],
            if: {
                properties: { policyType: { const: "Medicare" } },
            },
            then: {
                required: ["mbi"],
            },
            else: {
                required: ["policyNumber", "policyProvider"],
            },
        },
    },
    required: [
        "labInformation",
        "providerInformation",
        "specimenInformation",
        "tests",
        "diagnosis",
        "patientInformation",
        "insuranceInformation",
    ],
});
exports.default = labRequisitionJsonSchema;
